$(document).ready(function() {
  const data = $('.last-modified')
    .data('last-modified')
    .replace(/\//gi, '-')
  const now = moment().utc()
  const lastModified = moment(data).utc()
  const daysFromNow =
    now.diff(lastModified, 'days') - (now.diff(lastModified, 'days') % 7) + 1
  const before = lastModified.add(daysFromNow, 'days').format('YYYY年M月D日')
  const next = lastModified.add(7, 'days').format('YYYY年M月D日')
  $('.last-modified').append(before)
  $('.last-modified')
    .next()
    .append(next)
})
